import React, { useEffect, useState } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { accessService } from '../../services/central-api/access';
import { StyleProp, TextStyle } from 'react-native';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../FormDropDownPicker';

type Props = {
    actingBodyId: number | null;
    zIndex: number;
    disabled: boolean;
    labelStyle?: StyleProp<TextStyle>;
    includeAllOption?: boolean;
    viewStyle?: StyleProp<TextStyle>;
    required?: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: number;
    setValue: (value: number) => void;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function ActingBodiesCommandsDropdown({ value, setValue, actingBodyId, zIndex, disabled, labelStyle, includeAllOption, viewStyle, required, form, fieldName }: Props) {
    const [selectableActingBodyCommands, setSelectableActingBodyCommands] = useState<{ label: string; value: number; }[]>([]);

    async function getActingBodyCommands({ actingBodyId }: { actingBodyId: number; }) {
        try {
            const actingBody = await accessService.getActingBody(actingBodyId);

            if (!actingBody.actingBodyCommands) {
                setSelectableActingBodyCommands([]);
            } else {
                setSelectableActingBodyCommands([
                    ...(includeAllOption ? [{ value: 0, label: translate('masculineAll') }] : []),
                    ...actingBody.actingBodyCommands.map((role) => {
                        return {
                            value: role.id || 0,
                            label: role.name
                        };
                    })
                ]);
            }
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (actingBodyId) {
            getActingBodyCommands({ actingBodyId });
        }
    }, [actingBodyId]);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate('command')}
            items={selectableActingBodyCommands}
            zIndex={zIndex}
            disabled={disabled}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
            required={required}
            fieldName={fieldName}
            form={form}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={translate('command')}
                items={selectableActingBodyCommands}
                setValue={(val) => {
                    const resolved = typeof val === 'function' ? val(value) : val;
                    setValue(resolved as number);
                }}
                value={value}
                zIndex={zIndex}
                disabled={disabled}
                labelStyle={labelStyle}
                viewStyle={viewStyle}
                required={required}
            />
        );
    }
}

export default ActingBodiesCommandsDropdown;
